import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PageNotFound from "./pages/other/PageNotFound";
import ProtectionRoutes from "./ui/ProtectedRoute";
import AppLayout from "./ui/AppLayout";
import DashBoard from "./pages/dashboard/DashBoard";
import { SidebarProvider } from "./contexts/SidebarContext";
import Orders from "./pages/dashboard/Orders";
import Products from "./pages/dashboard/Products";
import Clients from "./pages/dashboard/Clients";
import Theme from "./pages/dashboard/Theme";
import Apps from "./pages/dashboard/Apps";
import Settings from "./pages/dashboard/Settings";
import { ModalsProvider } from "./contexts/ModalsContext";
import { Toaster } from "react-hot-toast";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ResetPassword from "./pages/auth/ResetPassword";
import ActivateAccount from "./pages/auth/ActivateAccount";
import ForgetPassword from "./pages/auth/ForgetPassword";
import GeneralSettings from "./pages/Settings/GeneralSettings";
import Maintenance from "./pages/Settings/Maintenance";
import LanguageSettings from "./pages/Settings/LanguageSettings";
import TaxesSettings from "./pages/Settings/TaxesSettings";
import UsersSettings from "./pages/Settings/UserSettings";
import BranchesSettings from "./pages/Settings/BranchesSettings";
import Subscribtion from "./pages/Settings/SubscribtionSettings";
import SettingsLayout from "./ui/SettingsLayout";
import Wallet from "./ui/Wallet";
import DomainSettings from "./pages/Settings/DomainSettings";
import TechnicalSupport from "./pages/dashboard/TechnicalSupport";
import CouponsSettings from "./pages/Settings/CouponsSettings";
import PaymentSettings from "./pages/Settings/PaymentSettings";
import VerificationForm from "./pages/Settings/VerificationForm";
import StoreBalanceHistory from "./components/storeBalance/StoreBalanceHistory";
import StoreCashHistory from "./components/storeBalance/StoreCashHistory";
import NotificationsPage from "./pages/notifications/Notifications";
import TermsAndPrivacyPolicySettings from "./pages/Settings/TermsAndPrivacyPolicySettings";
import QrCodeSettings from "./pages/Settings/QrCodeSettings";
import TidioChat from "./components/Todio/TidioChat";
import Cashier from "./pages/dashboard/Cashier";
import CashierHistory from "./pages/cashier History/CashierHistory";
import Tables from "./pages/dashboard/Tables";
import { useNetwork } from "./hooks/useNetwork";
import NoNetwork from "./pages/other/NoNetwork";
import Reports from "./pages/dashboard/Reports";
import Permissions from "./pages/Settings/Permissions";
import AddEmployee from "./pages/AddEmployee";
import EmployeeInfo from "./pages/EmployeeInfo";
import AcceptInvite from "./pages/auth/AcceptInvite";
import ChefsOrders from "./pages/ChefsOrders";
import ChefsOrdersHistory from "./pages/ChefsOrdersHistory";
import DriverOrdersBoard from "./pages/Roles/driver/DriverOrdersBoard";
import DriverOrdersHistory from "./pages/Roles/driver/DriverOrdersHistory";
import useMobileUpdate from "./hooks/useMobileUpdate";
import { MobileAppUpdate } from "./pages/other/MobileAppUpdate";
import Loader from "./components/loader/Loader";
import GroupedOrderTable from "./pages/dashboard/GroupedOrderTable";
import { useAndroidBackButton } from "./hooks/useAndroidBackButton";
import ClientOrder from "./components/clientsModal/ClientOrder";
import Reviews from "./pages/dashboard/Reviews";

function App() {

  const { isOnline } = useNetwork();

  // Initialize the back button handler For Mobile app
  useAndroidBackButton()

  const {
    isLoading,
    requiresUpdate,
    isMobile,
    error,
    openAppStore,
  } = useMobileUpdate();

  if (!isOnline) return <NoNetwork />;

  if (isMobile && isLoading) {
    return <Loader />
  }

  if (isMobile && requiresUpdate) {
    return <MobileAppUpdate error={error} openAppStore={openAppStore} />
  }

  return (
    <ModalsProvider>
      <SidebarProvider>
        <BrowserRouter>
          <TidioChat />
          <Routes>
            {/* App Layout */}
            <Route
              path="/"
              element={
                <ProtectionRoutes>
                  <AppLayout />
                </ProtectionRoutes>
              }
            >
              <Route index element={<Navigate to="dashboard" />} />
              <Route path="/dashboard" element={<DashBoard />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/reviews" element={<Reviews />} />
              <Route path="/products" element={<Products />} />
              <Route path="/cashier" element={<Cashier />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientOrder />} />
              <Route path="/apps" element={<Apps />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/cashierhistory" element={<CashierHistory />} />
              <Route path="/tables" element={<Tables />}>
                <Route path=":floorId/:tableId" element={<GroupedOrderTable />} />
              </Route>



              {/* Chef routes */}
              <Route path="/chefs-orders" element={<ChefsOrders />} />
              <Route path="/chefs-orders-history" element={<ChefsOrdersHistory />} />
              {/* Driver routes */}
              <Route path="/driver-orders" element={<DriverOrdersBoard />} />
              <Route path="/driver-orders-history" element={<DriverOrdersHistory />} />



              {/* Settings nested Routs and their layout */}
              <Route path="/settings" element={<SettingsLayout />}>
                <Route
                  path="general-settings"
                  element={<GeneralSettings />}
                />
                <Route
                  path="theme"
                  element={<Theme />} />
                <Route
                  path="maintenance-settings"
                  element={<Maintenance />}
                />
                <Route
                  path="language-settings"
                  element={<LanguageSettings />}
                />
                <Route path="taxes-settings" element={<TaxesSettings />} />
                <Route path="technical-support" element={<TechnicalSupport />} />
                <Route path="coupons" element={<CouponsSettings />} />
                <Route
                  path="branches-settings"
                  element={<BranchesSettings />}
                />
                <Route path="subscribtion" element={<Subscribtion />} />
                <Route
                  path="/settings/domain-settings"
                  element={<DomainSettings />}
                />
                <Route
                  path="/settings/payment-settings"
                  element={<PaymentSettings />}
                />
                <Route
                  path="/settings/verification"
                  element={<VerificationForm />}
                />

                <Route path="/settings/store-balance-history" element={<StoreBalanceHistory />} />
                <Route path="/settings/store-cash-history" element={<StoreCashHistory />} />
                <Route path="wallet-settings" element={<Wallet />} />
                <Route path="terms-privacy" element={<TermsAndPrivacyPolicySettings />} />
                <Route path="qrcode-settings" element={<QrCodeSettings />} />
                <Route path="permissions" element={<Permissions />}>
                  <Route path="add-employee" element={<AddEmployee />} />
                  <Route path="employee-info/:id" element={<EmployeeInfo />} />
                </Route>
              </Route>

              {/* Settings that didn't inherit the SettingsLayout */}
              <Route path="/settings/user-settings" element={<UsersSettings />} />

            </Route>

            {/* Single Pages Outside the App */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/activate-account" element={<ActivateAccount />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>

          <Toaster position="top-center" reverseOrder={false} containerStyle={{
            zIndex: 99999999999, // ✅ This sets z-index on the container div
          }} toastOptions={{ style: { zIndex: 99999999999,maxWidth: "60%" } }} />
        </BrowserRouter>
      </SidebarProvider>
    </ModalsProvider>
  );
}

export default App;